import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './GeneralDepartment.css';

import BannerSection from '../../Pages/Alumni/Partials/Banner';

const GeneralDepartment = () => {

  return (

    <>
      <BannerSection />
      <section className="pt_80 pb_80 general-department-section" style={{ textAlign: 'justify' }}>
        <div className="container">
          <div className="row">
            {/* Desktop Sidebar */}
            <div className="col-md-3 d-none d-md-block">
              <div className="sidebar-medicine-medicine-medicine">
                <nav className="nav flex-column" id="contentTabs" role="tablist">
                  <a className="nav-link active" data-bs-toggle="tab" href="#about">About the Department</a>
                  <a className="nav-link" data-bs-toggle="tab" href="#team">The Team</a>
                  <a className="nav-link" data-bs-toggle="tab" href="#focus">Focus</a>
                  <a className="nav-link" data-bs-toggle="tab" href="#Patient-care-Services">Patient care Services</a>
                  <a className="nav-link" data-bs-toggle="tab" href="#Projects">Projects</a>
                  <a className="nav-link" data-bs-toggle="tab" href="#Conferences">Conferences & Webinars</a>
                </nav>
              </div>
            </div>

            {/* Desktop Content */}
            <div className="col-md-9 d-none d-md-block">
              <div className="tab-content dep-content">

                {/* About Tab */}
                <div className="tab-pane fade show active" id="about">
                  <div className="document-box-medicine-medicine">
                    <div className="sec-title text-center py-3">
                      <h2>About the Department</h2>
                    </div>

                    <p >
                      The Department of General Medicine is one of the main departments in the hospital which provides
                      general medical care for adult patients. The common medical ailments treated include acute and
                      chronic infections, metabolic disorders such as hypertension, obesity, diabetes mellitus,
                      endocrine disorders, liver disorders, renal disorders, cardiac disorders neurological ailments,
                      nutritional disorders, geriatric care, hematological disorders and critical care illness.
                      This department is the backbone for the entire hospital and fetching opinions and advice to
                      various departments on demand.
                    </p>
                  </div>
                </div>

                {/* Team Tab */}
                <div className="tab-pane fade" id="team">
                  <div className="document-box-medicine-medicine"> <div className="sec-title text-center py-3">
                    <h2>The Team</h2>
                  </div>

                    <p style={{ textAlign: 'justify' }}>
                      <strong>Click Here for :</strong>
                      <Link
                        to="/faculty-list"
                        className="d-inline-flex align-items-center gap-2"
                      >
                        <i className="fa fa-hand-o-right ms-2 text-danger"></i>
                        Teaching Faculty List
                      </Link>
                    </p>
                    <p >
                      The Department of General Medicine is one of the main departments The team is headed by
                      Prof V.R. Mohan Rao and is an accurate admixture of experienced senior and dynamic junior
                      physicians who are highly qualified, competent, dedicated and altruistic.
                    </p>
                    <div className='row d-flex justify-content-center align-items-center'>
                      <div className='col-md-4 col-12'>
                        <img
                          src="https://care.edu.in/wp-content/uploads/2020/07/gmteam.png"
                          alt="General Medicine Team"
                          className="img-fluid"
                          style={{ borderRadius: "10px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Focus Tab */}
                <div className="tab-pane fade" id="focus">
                  <ul className="nav nav-tabs d-flex justify-content-center align-items-center" id="campusTabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="Patient-tab" data-bs-toggle="tab" data-bs-target="#Patient" type="button" role="tab">
                        Patient Care
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="Teaching-tab" data-bs-toggle="tab" data-bs-target="#Teaching" type="button" role="tab">
                        Teaching
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="Research-tab" data-bs-toggle="tab" data-bs-target="#Research" type="button" role="tab">
                        Research
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content mt-3" id="campusTabsContent">
                    <div className="tab-pane fade show active" id="Patient" role="tabpanel">
                      <div className="sec-title text-center py-3">
                        <h2>Patient Care</h2>
                      </div>

                      <div className="row mb-3">
                        <div>
                          <p >
                            The Department of General Medicine provides outpatient services from 08:30 AM to 08:00 PM on all days.
                            On holidays the services are restricted from 8:30 AM to 02:00 PM.
                          </p>
                          <p  >
                            Inpatient care is facilitated by means of eight medical units providing utmost care to the sick patients.
                            Patients can choose between general wards, semiprivate rooms and private rooms.
                          </p>

                          <div className='row d-flex justify-content-center'>

                            <div className='col-md-4 col-12'>
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/gmpatientcare.png"
                                alt="Patient Care"
                                className="img-fluid" style={{ borderRadius: "10px", width: "100%" }}
                              />
                            </div>
                          </div>

                          <p  >
                            In addition, the department has provided unique health care services to the poor and downtrodden
                            at their door steps by conducting rural health camps for the detection of communicable as well
                            as non-communicable diseases. For minor ailments drugs are provided free of cost at the camp site.
                          </p>
                          <p  >
                            Patients requiring further medical intervention will be referred to the hospital for further work up.
                            In addition to the above services specialist consultation is provided to peripheral centers such as
                            our urban health centre at Karapakkam, Government Primary health center Kelambakkam and rural health
                            centre Poonjeri.
                          </p>  <div className='row d-flex justify-content-center'>

                            <div className='col-md-4 col-12'>
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/gmpt2.png"
                                alt="Patient Care"
                                className="img-fluid" style={{ borderRadius: "10px", width: "100%" }}
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div className="tab-pane fade" id="Teaching" role="tabpanel">
                      <div className="sec-title text-center py-3">
                        <h2>Teaching</h2>
                      </div>

                      <div className="row mb-3">
                        <div>
                          <p >
                            Another prime focus of the Department of General Medicine is medical education which involves
                            imparting knowledge to the Undergraduate (MBBS, BDS and BPT) and Postgraduate (MD) Medical students.
                          </p>
                          <p  >
                            The teaching learning methods for the MBBS students includes theory classes, Outpatient clinic,
                            Bedside clinical teaching, Clinical Tutorials, Vertical integration programs, monthly CPC,
                            Skills lab training, BLS training, weekly seminars and symposium, CME programs, conferences and workshops.
                            Methodology adopted for slow learners is organizing special bedside clinical classes by the senior faculty
                            and weekly clinical orientated theory tests.
                          </p>
                          <p  >
                            For BDS students, theory classes and bedside teaching is carried out, while for BPT student's theory
                            classes are conducted.
                          </p>
                          <p  >
                            The teaching methodology adopted for the Post graduate students includes Outpatient clinic,
                            Bedside clinical teaching, lectures in basic sciences, diagnostic challenges, laboratory approach
                            to common medical disorders, update on emergencies, journal clubs, interdepartmental discussions,
                            CME, Workshops and conferences. Online clinical discussion by distinguished faculty has also been introduced.
                          </p>

                          <div className='row d-flex justify-content-center'>

                            <div className='col-md-4 col-12'>
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/gmpt3.png"
                                alt="Patient Care"
                                className="img-fluid" style={{ borderRadius: "10px", width: "100%" }}
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div className="tab-pane fade" id="Research" role="tabpanel">
                      <div className="sec-title text-center py-3">
                        <h2>Research</h2>
                      </div>

                      <p >
                        Thrust areas for research include COVID 19 and its biomarkers, Cardiac enzymes in kidney disease,
                        multidrug resistant Acinetobacter species, chronic kidney disease, disorders of cardiac rhythm,
                        CNS disorders, tuberculosis, Dengue, peripheral neuropathy in diabetics, sepsis and metabolic disorders.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Patient Care Services Tab */}
                <div className="tab-pane fade" id="Patient-care-Services">
                  <ul className="nav nav-tabs d-flex justify-content-center align-items-center" id="serviceTabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="Outpatient-tab" data-bs-toggle="tab" data-bs-target="#Outpatient" type="button" role="tab">
                        Outpatient
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="Inpatient-tab" data-bs-toggle="tab" data-bs-target="#Inpatient" type="button" role="tab">
                        Inpatient
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="cases-tab" data-bs-toggle="tab" data-bs-target="#cases" type="button" role="tab">
                        Interesting cases
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="Outreach-tab" data-bs-toggle="tab" data-bs-target="#Outreach" type="button" role="tab">
                        Outreach Activities
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content mt-3" id="serviceTabsContent">
                    <div className="tab-pane fade show active" id="Outpatient" role="tabpanel">
                      <div className="sec-title text-center py-3">
                        <h2>Outpatient</h2>
                      </div>

                      <div className="row mb-3">
                        <div>
                          <p >
                            The Department of General Medicine provides outpatient services from 08:30 AM to 08:00 PM on all days.
                            During holidays the services are restricted from 8:30 AM to 02:00 PM.
                          </p>
                          <p  >
                            <strong>Diabetic clinic:</strong> The department of General Medicine has systematized a diabetic
                            speciality clinic which functions 6 days a week from 08.30 AM to 04.00PM, wherein glycemic control
                            of patients is assessed and appropriate medications are prescribed. The clinic is also provided by
                            qualified dietician for proper dietary advise to the patients. The minor complications of diabetes
                            mellitus such as neuropathy and retinopathy are screened in the separate premises adjacent to diabetic clinic.
                          </p>
                          <p  >
                            <strong>Speciality clinics:</strong> The Department of General Medicine has dedicated specialty
                            clinics conducted once in a week as per schedule with concerned super specialists. Currently the
                            following specialty clinics are functioning
                          </p>
                          <div className='row d-flex justify-content-center'>

                            <div className='col-md-4 col-12'>
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/spc.png"
                                alt="Patient Care"
                                className="img-fluid" style={{ borderRadius: "10px", width: "100%" }}
                              />
                            </div>
                          </div>

                          <div className="table-responsive  d-flex justify-content-center">
                            <table className="table table-bordered" id="SpecialtyTable" style={{ width: '75%' }}>
                              <thead>
                                <tr>
                                  <th colSpan="2">General Medicine – 02</th>
                                </tr>
                                <tr>
                                  <th>Specialty</th>
                                  <th>Day</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr><td>Geriatrics</td><td>Tuesday</td></tr>
                                <tr><td>Hypertension</td><td>Wednesday</td></tr>
                                <tr><td>Diabetes</td><td>Thursday</td></tr>
                                <tr><td>Hematology</td><td>Friday</td></tr>
                                <tr><td>Endocrine</td><td>Saturday</td></tr>
                                <tr><td>Cardiovascular</td><td>Tuesday</td></tr>
                                <tr><td>Nephrology</td><td>Wednesday</td></tr>
                                <tr><td>Gastroenterology</td><td>Thursday</td></tr>
                                <tr><td>Neurology</td><td>Friday</td></tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane fade" id="Inpatient" role="tabpanel">
                      <div className="sec-title text-center py-3">
                        <h2>Inpatient</h2>
                      </div>

                      <div className="row mb-3">
                        <div>
                          <p >
                            Inpatient care is facilitated by means of eight medical units providing utmost care to the sick patients.
                            In addition to general medical wards the patients are also provided medical care in special wards with
                            all basic amenities based on their option.
                          </p>
                          <p  >
                            Severely ill patients are triaged at the zero-delay ward and are transferred to intensive medical
                            care unit for prompt treatment.
                          </p>
                          <p  >
                            The salient feature of intensive care unit is that the unit is fully equipped with all necessary
                            lifesaving equipment like multipara monitors, ventilators, centralized oxygen and suction facilities,
                            infusion pumps, syringe pump, defibrillators etc. Medical emergencies such as acute myocardial infarction,
                            stroke, metabolic derangements and toxicological emergencies like acute poisoning, snake bite and
                            scorpion sting are taken care of in the intensive medical care unit.
                          </p>

                          <div className='row d-flex justify-content-center'>

                            <div className='col-md-4 col-12'>
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/inpt.png"
                                alt="Patient Care"
                                className="img-fluid" style={{ borderRadius: "10px", width: "100%" }}
                              />
                            </div>
                            <div className='col-md-4 col-12'>
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/inpt2.png"
                                alt="Patient Care"
                                className="img-fluid" style={{ borderRadius: "10px", width: "100%" }}
                              />
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>

                    <div className="tab-pane fade" id="cases" role="tabpanel">
                      <div className="sec-title text-center py-3">
                        <h2>Interesting cases (June 2019-2020)</h2>
                      </div>

                      <div className="table-responsive p-2 d-flex justify-content-center">
                        <table className="table table-bordered" id="casesTable" style={{ width: '75%' }}>
                          <tbody>
                            {[
                              "Downs arthropathy",
                              "Polymyositis with multiple angiomyolipoma",
                              "Unusual case of intracranial abscess",
                              "Cerebellopontine angle tumor",
                              "Subclavian Steel syndrome with posterior circulatory stroke",
                              "Hemorrhagic pericarditis",
                              "Triple trouble (thoracic outlet syndrome, macular hole, myeloma)",
                              "Sickle cell crisis, Portal biliopathy",
                              "Unusual case of PSGN with multisystemic infection",
                              "Cholangiocarcinoma mimicking primary biliary cirrhosis",
                              "Haemolytic Crisis",
                              "Pituitary macroadenoma",
                              "Sjogren's overlap syndrome",
                              "Polycythemia causing sensorineural hearing loss",
                              "Rhupus syndrome",
                              "Subdural empyema following CSOM",
                              "Henoch Schoenlein purpura",
                              "Unusual Case of fever/ cough/ bleeding manifestation.",
                              "Interesting case of Lower GI Bleed",
                              "Epidural abscess"
                            ].map((caseText, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{caseText}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="tab-pane fade" id="Outreach" role="tabpanel">
                      <div className="sec-title text-center py-3">
                        <h2>Outreach Activities</h2>
                      </div>

                      <p >
                        The department has provided unique services to the poor and downtrodden at their door steps by
                        conducting rural health camps for the detection of communicable as well as non-communicable diseases.
                        For minor ailments drugs are provided free of cost at the camp site. Patients with notable disorders
                        will be referred to the hospital for further work up. In addition to the above services specialist
                        consultation is provided to peripheral centres such as our urban health centre at Karapakkam,
                        Government Primary health centre Kelambakkam and rural health centre Poonjeri.
                      </p>
                      <p  >
                        Presently, in view of the COVID 19 pandemic, the department provides telephonic consultation for
                        remote monitoring of COVID19 patients in addition to inpatient care.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Projects Tab */}
                <div className="tab-pane fade" id="Projects">
                  <div className="sec-title text-center py-3">
                    <h2>Ongoing Projects by Faculty</h2>
                  </div>

                  <div className="table-responsive  d-flex justify-content-center">
                    <table className="table table-bordered" id="facultyprojectsTable">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Name of the Investigators</th>
                          <th>Title</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { investigators: "Dr. Durga Krishnan", title: "Clinical, microbiological and laboratory profile of Acinetobacter infections in a tertiary care hospital in South India" },
                          { investigators: "Dr. Vigneswaran", title: "Cardiac troponins in Stage III & IV Chronic Kidney Disease" },
                          { investigators: "Dr. Vrinda V", title: "Knowledge attitudes and practices towards prevention and early detection of chronic kidney disease among high risk patients attending a tertiary care centre" },
                          { investigators: "Dr. Ananthakumar P K", title: "Study on the effect of teneligliptin on QT interval in frail and pre frail elderly population" },
                          { investigators: "Dr. Ananthakumar P K <br> Prof V R Mohan Rao", title: "Randomized study of the effect of methylprednisolone and dexamethasone on the effect of IL6 and clinical outcome in severe COVID19" },
                          { investigators: "Dr. Nirmala Devi <br> Prof V R Mohan Rao", title: "Serial Troponin I monitoring in acute ischemic stroke patients as a prognostic marker in predicting underlying undiagnosed cardiovascular morbidity" }
                        ].map((project, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td dangerouslySetInnerHTML={{ __html: project.investigators }} />
                            <td>{project.title}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="sec-title text-center py-3">
                    <h2>Completed projects</h2>
                  </div>

                  <div className="table-responsive  d-flex justify-content-center">
                    <table className="table table-bordered" id="studentsprojectTable">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Name of the Investigators</th>
                          <th>Title</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { investigators: "Dr Vishal V", title: "Relationship between left atrial enlargement and ischemic stroke in patients attending a tertiary care hospital in South India" },
                          { investigators: "Dr. Gnanadeepan", title: "Scoring for diagnosis of tuberculous meningitis –Validating in our hospital population" },
                          { investigators: "Dr. VenkatSaiSuhas", title: "Correlation of serum phosphorus and magnesium levels and severity of peripheral neuropathy in patients with type 2 diabetes" },
                          { investigators: "Dr. Thejesh C V", title: "Pattern of Infections in Chronic kidney disease, their short-term outcome during hospitalization and the impact of infections on progression of chronic kidney disease-A prospective cohort study in a Tertiary care center" },
                          { investigators: "Dr ShreedeveShamritha", title: "Albuminuria as a predictor of CKD in patients with NAFLD" },
                          { investigators: "DrYalamanchi Sriram Srujan", title: "Study on assessment outcome of patients in sepsis with supplementing antioxidants and micronutrients" }
                        ].map((project, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{project.investigators}</td>
                            <td>{project.title}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Conferences Tab */}
                <div className="tab-pane fade" id="Conferences">
                  <ul className="nav nav-tabs d-flex justify-content-center align-items-center" id="conferenceTabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="Organized-tab" data-bs-toggle="tab" data-bs-target="#Organized" type="button" role="tab">
                        Organized
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="Series-tab" data-bs-toggle="tab" data-bs-target="#Series" type="button" role="tab">
                        Webinar Series
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content mt-3" id="conferenceTabsContent">
                    <div className="tab-pane fade show active" id="Organized" role="tabpanel">
                      {/* Organized conferences content - similar structure as original */}
                      <div className="table-responsive  d-flex justify-content-center">
                        <table className="table table-bordered" id="conferenceTable">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Theme</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr><td>17/08/2019</td><td>CHETMEDICON 2019</td><td>National speakers</td></tr>
                            <tr><td>21/03/2020</td><td>ECG workshop</td><td>Faculty of medicine</td></tr>
                            <tr><td>14-21/11/2019</td><td>World Diabetic week guest lecture series</td><td>State speakers</td></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="tab-pane fade" id="Series" role="tabpanel">
                      {/* Webinar series content - similar structure as original */}
                      <div className="table-responsive  d-flex justify-content-center">
                        <table className="table table-bordered" id="facultyprojectsTable">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Date</th>
                              <th>Topic</th>
                              <th>Speaker</th>
                              <th>Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr><td>1</td><td>27/06/2020</td><td>Clinical discussion on paraparesis</td><td>Prof Hariharan, Director MMC</td><td>2.00PM - 04.00PM</td></tr>
                            <tr><td>2</td><td>04/07/2020</td><td>Clinical discussion on abdomen - DCLD</td><td>Prof Hariharan, Director MMC</td><td>2.00PM - 04.00PM</td></tr>
                            <tr><td>3</td><td>04/07/2020</td><td>Viral pneumonias with emphasis on COVID 19 pneumonia</td><td>Dr Bharath Kathi, S V Medical College, Thirupathi</td><td>6.00PM - 08.00PM</td></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div className="col-12 d-md-none">
              <div className="accordion" id="general-medicine-accordion">

                {/* About Mobile */}
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#accordionone">
                      About the Department
                    </button>
                  </h5>
                  <div id="accordionone" className="accordion-collapse collapse show" data-bs-parent="#general-medicine-accordion">
                    <div className="accordion-body">
                      <div className="sec-title text-center py-3">
                        <h2>About the Department</h2>
                      </div>
                      <p >
                        The Department of General Medicine is one of the main departments in the hospital which provides
                        general medical care for adult patients. The common medical ailments treated include acute and
                        chronic infections, metabolic disorders such as hypertension, obesity, diabetes mellitus,
                        endocrine disorders, liver disorders, renal disorders, cardiac disorders neurological ailments,
                        nutritional disorders, geriatric care, hematological disorders and critical care illness.
                        This department is the backbone for the entire hospital and fetching opinions and advice to
                        various departments on demand.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Team Mobile */}
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordiontwo">
                      The Team
                    </button>
                  </h5>
                  <div id="accordiontwo" className="accordion-collapse collapse" data-bs-parent="#general-medicine-accordion">
                    <div className="accordion-body">
                      <div className="sec-title text-center py-3">
                        <h2>The Team</h2>
                      </div>
                      <p style={{ textAlign: 'justify' }}>
                        <strong>Click Here for :</strong>
                        <a
                          href="https://caredemo.care.edu.in/pages/footer-pages/faculty-list.php"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-inline-flex align-items-center gap-2"
                        >
                          <i className="fa fa-hand-o-right ms-2 text-danger "></i>
                          Teaching Faculty List
                        </a>
                      </p>
                      <p >
                        The Department of General Medicine is one of the main departments The team is headed by
                        Prof V.R. Mohan Rao and is an accurate admixture of experienced senior and dynamic junior
                        physicians who are highly qualified, competent, dedicated and altruistic.
                      </p>
                      <img
                        src="https://care.edu.in/wp-content/uploads/2020/07/gmteam.png"
                        alt="General Medicine Team"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>

                {/* Focus Mobile */}
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionthree">
                      Focus
                    </button>
                  </h5>
                  <div id="accordionthree" className="accordion-collapse collapse" data-bs-parent="#general-medicine-accordion">
                    <div className="accordion-body">
                      <ul className="nav nav-tabs  d-flex justify-content-center align-items-center" id="campus1Tabs" role="tablist">
                        <li className="nav-item" role="presentation">
                          <button className="nav-link active" id="Patient1-tab" data-bs-toggle="tab" data-bs-target="#Patient1" type="button" role="tab">
                            Patient Care
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button className="nav-link" id="Teaching1-tab" data-bs-toggle="tab" data-bs-target="#Teaching1" type="button" role="tab">
                            Teaching
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button className="nav-link" id="Research1-tab" data-bs-toggle="tab" data-bs-target="#Research1" type="button" role="tab">
                            Research
                          </button>
                        </li>
                      </ul>

                      <div className="tab-content mt-3" id="campus1TabsContent">
                        <div className="tab-pane fade show active" id="Patient1" role="tabpanel">
                          <div className="sec-title text-center py-3">
                            <h2>Patient Care</h2>
                          </div>
                          <div className="row mb-3">
                            <div>
                              <p >
                                The Department of General Medicine provides outpatient services from 08:30 AM to 08:00 PM on all days.
                                On holidays the services are restricted from 8:30 AM to 02:00 PM.
                              </p>
                              <p  >
                                Inpatient care is facilitated by means of eight medical units providing utmost care to the sick patients.
                                Patients can choose between general wards, semiprivate rooms and private rooms.
                              </p>
                              <div className='row d-flex justify-content-center'>

                                <div className='col-md-4 col-12'>
                                  <img
                                    src="https://care.edu.in/wp-content/uploads/2020/07/gmpatientcare.png"
                                    alt="Patient Care"
                                    className="img-fluid mb-3 mb-md-0" style={{ borderRadius: "10px", width: "100%" }}
                                  />
                                </div>
                              </div>
                              <p  >
                                In addition, the department has provided unique health care services to the poor and downtrodden
                                at their door steps by conducting rural health camps for the detection of communicable as well
                                as non-communicable diseases. For minor ailments drugs are provided free of cost at the camp site.
                              </p>
                              <p  >
                                Patients requiring further medical intervention will be referred to the hospital for further work up.
                                In addition to the above services specialist consultation is provided to peripheral centers such as
                                our urban health centre at Karapakkam, Government Primary health center Kelambakkam and rural health
                                centre Poonjeri.
                              </p>
                              <div className='col-md-4 col-12'>
                                <img
                                  src="https://care.edu.in/wp-content/uploads/2020/07/gmpt2.png"
                                  alt="Patient Care"
                                  className="img-fluid mb-3 mb-md-0" style={{ borderRadius: "10px", width: "100%" }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane fade" id="Teaching1" role="tabpanel">
                          <div className="sec-title text-center py-3">
                            <h2>Teaching</h2>
                          </div>
                          <div className="row mb-3">
                            <div>
                              <p >
                                Another prime focus of the Department of General Medicine is medical education which involves
                                imparting knowledge to the Undergraduate (MBBS, BDS and BPT) and Postgraduate (MD) Medical students.
                              </p>
                              <p  >
                                The teaching learning methods for the MBBS students includes theory classes, Outpatient clinic,
                                Bedside clinical teaching, Clinical Tutorials, Vertical integration programs, monthly CPC,
                                Skills lab training, BLS training, weekly seminars and symposium, CME programs, conferences and workshops.
                                Methodology adopted for slow learners is organizing special bedside clinical classes by the senior faculty
                                and weekly clinical orientated theory tests.
                              </p>
                              <p  >
                                For BDS students, theory classes and bedside teaching is carried out, while for BPT student's theory
                                classes are conducted.
                              </p>
                              <p  >
                                The teaching methodology adopted for the Post graduate students includes Outpatient clinic,
                                Bedside clinical teaching, lectures in basic sciences, diagnostic challenges, laboratory approach
                                to common medical disorders, update on emergencies, journal clubs, interdepartmental discussions,
                                CME, Workshops and conferences. Online clinical discussion by distinguished faculty has also been introduced.
                              </p>
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/gmpt3.png"
                                alt="Teaching"
                                className="img-fluid"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane fade" id="Research1" role="tabpanel">
                          <div className="sec-title text-center py-3">
                            <h2>Research</h2>
                          </div>
                          <p >
                            Thrust areas for research include COVID 19 and its biomarkers, Cardiac enzymes in kidney disease,
                            multidrug resistant Acinetobacter species, chronic kidney disease, disorders of cardiac rhythm,
                            CNS disorders, tuberculosis, Dengue, peripheral neuropathy in diabetics, sepsis and metabolic disorders.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Patient Care Services Mobile */}
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionfour">
                      Patient care Services
                    </button>
                  </h5>
                  <div id="accordionfour" className="accordion-collapse collapse" data-bs-parent="#general-medicine-accordion">
                    <div className="accordion-body">
                      <ul className="nav nav-tabs d-flex justify-content-center align-items-center" id="service1Tabs" role="tablist">
                        <li className="nav-item" role="presentation">
                          <button className="nav-link active" id="Outpatient1-tab" data-bs-toggle="tab" data-bs-target="#Outpatient1" type="button" role="tab">
                            Outpatient
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button className="nav-link" id="Inpatient1-tab" data-bs-toggle="tab" data-bs-target="#Inpatient1" type="button" role="tab">
                            Inpatient
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button className="nav-link" id="cases1-tab" data-bs-toggle="tab" data-bs-target="#cases1" type="button" role="tab">
                            Interesting cases
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button className="nav-link" id="Outreach1-tab" data-bs-toggle="tab" data-bs-target="#Outreach1" type="button" role="tab">
                            Outreach Activities
                          </button>
                        </li>
                      </ul>

                      <div className="tab-content mt-3" id="service1TabsContent">
                        <div className="tab-pane fade show active" id="Outpatient1" role="tabpanel">
                          <div className="sec-title text-center py-3">
                            <h2>Outpatient</h2>
                          </div>
                          <div className="row mb-3">
                            <div>
                              <p >
                                The Department of General Medicine provides outpatient services from 08:30 AM to 08:00 PM on all days.
                                During holidays the services are restricted from 8:30 AM to 02:00 PM.
                              </p>
                              <p  >
                                <strong>Diabetic clinic:</strong> The department of General Medicine has systematized a diabetic
                                speciality clinic which functions 6 days a week from 08.30 AM to 04.00PM, wherein glycemic control
                                of patients is assessed and appropriate medications are prescribed. The clinic is also provided by
                                qualified dietician for proper dietary advise to the patients. The minor complications of diabetes
                                mellitus such as neuropathy and retinopathy are screened in the separate premises adjacent to diabetic clinic.
                              </p>
                              <p  >
                                <strong>Speciality clinics:</strong> The Department of General Medicine has dedicated specialty
                                clinics conducted once in a week as per schedule with concerned super specialists. Currently the
                                following specialty clinics are functioning
                              </p>
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/spc.png"
                                alt="Specialty Clinics"
                                className="img-fluid"
                              />
                              <div className="table-responsive p-3">
                                <table className="table table-bordered" id="SpecialtyTable">
                                  <thead>
                                    <tr>
                                      <th colSpan="2">General Medicine – 02</th>
                                    </tr>
                                    <tr>
                                      <th>Specialty</th>
                                      <th>Day</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr><td>Geriatrics</td><td>Tuesday</td></tr>
                                    <tr><td>Hypertension</td><td>Wednesday</td></tr>
                                    <tr><td>Diabetes</td><td>Thursday</td></tr>
                                    <tr><td>Hematology</td><td>Friday</td></tr>
                                    <tr><td>Endocrine</td><td>Saturday</td></tr>
                                    <tr><td>Cardiovascular</td><td>Tuesday</td></tr>
                                    <tr><td>Nephrology</td><td>Wednesday</td></tr>
                                    <tr><td>Gastroenterology</td><td>Thursday</td></tr>
                                    <tr><td>Neurology</td><td>Friday</td></tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane fade" id="Inpatient1" role="tabpanel">
                          <div className="sec-title text-center py-3">
                            <h2>Inpatient</h2>
                          </div>
                          <div className="row mb-3">
                            <div>
                              <p >
                                Inpatient care is facilitated by means of eight medical units providing utmost care to the sick patients.
                                In addition to general medical wards the patients are also provided medical care in special wards with
                                all basic amenities based on their option.
                              </p>
                              <p  >
                                Severely ill patients are triaged at the zero-delay ward and are transferred to intensive medical
                                care unit for prompt treatment.
                              </p>
                              <p  >
                                The salient feature of intensive care unit is that the unit is fully equipped with all necessary
                                lifesaving equipment like multipara monitors, ventilators, centralized oxygen and suction facilities,
                                infusion pumps, syringe pump, defibrillators etc. Medical emergencies such as acute myocardial infarction,
                                stroke, metabolic derangements and toxicological emergencies like acute poisoning, snake bite and
                                scorpion sting are taken care of in the intensive medical care unit.
                              </p>
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/inpt.png"
                                alt="Inpatient Care 1"
                                className="img-fluid"
                              />
                              <img
                                src="https://care.edu.in/wp-content/uploads/2020/07/inpt2.png"
                                alt="Inpatient Care 2"
                                className="img-fluid"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane fade" id="cases1" role="tabpanel">
                          <div className="sec-title text-center py-3">
                            <h2>Interesting cases (June 2019-2020)</h2>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-bordered" id="casesTable">
                              <tbody>
                                {[
                                  "Downs arthropathy",
                                  "Polymyositis with multiple angiomyolipoma",
                                  "Unusual case of intracranial abscess",
                                  "Cerebellopontine angle tumor",
                                  "Subclavian Steel syndrome with posterior circulatory stroke",
                                  "Hemorrhagic pericarditis",
                                  "Triple trouble (thoracic outlet syndrome, macular hole, myeloma)",
                                  "Sickle cell crisis, Portal biliopathy",
                                  "Unusual case of PSGN with multisystemic infection",
                                  "Cholangiocarcinoma mimicking primary biliary cirrhosis",
                                  "Haemolytic Crisis",
                                  "Pituitary macroadenoma",
                                  "Sjogren's overlap syndrome",
                                  "Polycythemia causing sensorineural hearing loss",
                                  "Rhupus syndrome",
                                  "Subdural empyema following CSOM",
                                  "Henoch Schoenlein purpura",
                                  "Unusual Case of fever/ cough/ bleeding manifestation.",
                                  "Interesting case of Lower GI Bleed",
                                  "Epidural abscess"
                                ].map((caseText, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{caseText}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div className="tab-pane fade" id="Outreach1" role="tabpanel">
                          <div className="sec-title text-center py-3">
                            <h2>Outreach Activities</h2>
                          </div>
                          <p >
                            The department has provided unique services to the poor and downtrodden at their door steps by
                            conducting rural health camps for the detection of communicable as well as non-communicable diseases.
                            For minor ailments drugs are provided free of cost at the camp site. Patients with notable disorders
                            will be referred to the hospital for further work up. In addition to the above services specialist
                            consultation is provided to peripheral centres such as our urban health centre at Karapakkam,
                            Government Primary health centre Kelambakkam and rural health centre Poonjeri.
                          </p>
                          <p  >
                            Presently, in view of the COVID 19 pandemic, the department provides telephonic consultation for
                            remote monitoring of COVID19 patients in addition to inpatient care.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Projects Mobile */}
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionfive">
                      Projects
                    </button>
                  </h5>
                  <div id="accordionfive" className="accordion-collapse collapse" data-bs-parent="#general-medicine-accordion">
                    <div className="accordion-body">
                      <div className="sec-title text-center py-3">
                        <h2>Ongoing Projects by Faculty</h2>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-bordered" id="facultyprojectsTable">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Name of the Investigators</th>
                              <th>Title</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[
                              { investigators: "Dr. Durga Krishnan", title: "Clinical, microbiological and laboratory profile of Acinetobacter infections in a tertiary care hospital in South India" },
                              { investigators: "Dr. Vigneswaran", title: "Cardiac troponins in Stage III & IV Chronic Kidney Disease" },
                              { investigators: "Dr. Vrinda V", title: "Knowledge attitudes and practices towards prevention and early detection of chronic kidney disease among high risk patients attending a tertiary care centre" },
                              { investigators: "Dr. Ananthakumar P K", title: "Study on the effect of teneligliptin on QT interval in frail and pre frail elderly population" },
                              { investigators: "Dr. Ananthakumar P K & Prof V R Mohan Rao", title: "Randomized study of the effect of methylprednisolone and dexamethasone on the effect of IL6 and clinical outcome in severe COVID19" },
                              { investigators: "Dr. Nirmala Devi & Prof V R Mohan Rao", title: "Serial Troponin I monitoring in acute ischemic stroke patients as a prognostic marker in predicting underlying undiagnosed cardiovascular morbidity" }
                            ].map((project, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{project.investigators}</td>
                                <td>{project.title}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="sec-title text-center py-3">
                        <h2>Completed projects</h2>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-bordered" id="studentsprojectTable">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Name of the Investigators</th>
                              <th>Title</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[
                              { investigators: "Dr Vishal V", title: "Relationship between left atrial enlargement and ischemic stroke in patients attending a tertiary care hospital in South India" },
                              { investigators: "Dr. Gnanadeepan", title: "Scoring for diagnosis of tuberculous meningitis –Validating in our hospital population" },
                              { investigators: "Dr. VenkatSaiSuhas", title: "Correlation of serum phosphorus and magnesium levels and severity of peripheral neuropathy in patients with type 2 diabetes" },
                              { investigators: "Dr. Thejesh C V", title: "Pattern of Infections in Chronic kidney disease, their short-term outcome during hospitalization and the impact of infections on progression of chronic kidney disease-A prospective cohort study in a Tertiary care center" },
                              { investigators: "Dr ShreedeveShamritha", title: "Albuminuria as a predictor of CKD in patients with NAFLD" },
                              { investigators: "DrYalamanchi Sriram Srujan", title: "Study on assessment outcome of patients in sepsis with supplementing antioxidants and micronutrients" }
                            ].map((project, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{project.investigators}</td>
                                <td>{project.title}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Conferences Mobile */}
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionsix">
                      Conferences & Webinars
                    </button>
                  </h5>
                  <div id="accordionsix" className="accordion-collapse collapse" data-bs-parent="#general-medicine-accordion">
                    <div className="accordion-body">
                      <ul className="nav nav-tabs justify-content-center" id="conference1Tabs" role="tablist">
                        <li className="nav-item">
                          <button className="nav-link active" id="Organized1-tab" data-bs-toggle="tab" data-bs-target="#Organized1" type="button" role="tab">
                            Organized
                          </button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" id="Series1-tab" data-bs-toggle="tab" data-bs-target="#Series1" type="button" role="tab">
                            Webinar Series
                          </button>
                        </li>
                      </ul>

                      <div className="tab-content mt-3" id="conference1TabsContent">
                        <div className="tab-pane fade show active" id="Organized1" role="tabpanel">
                          <div className="table-responsive">
                            <table className="table table-bordered" id="conferenceTable">
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Theme</th>
                                  <th>Details</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr><td>17/08/2019</td><td>CHETMEDICON 2019</td><td>National speakers</td></tr>
                                <tr><td>21/03/2020</td><td>ECG workshop</td><td>Faculty of medicine</td></tr>
                                <tr><td>14-21/11/2019</td><td>World Diabetic week guest lecture series</td><td>State speakers</td></tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div className="tab-pane fade" id="Series1" role="tabpanel">
                          <div className="table-responsive">
                            <table className="table table-bordered" id="facultyprojectsTable">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Date</th>
                                  <th>Topic</th>
                                  <th>Speaker</th>
                                  <th>Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr><td>1</td><td>27/06/2020</td><td>Clinical discussion on paraparesis</td><td>Prof Hariharan, Director MMC</td><td>2.00PM - 04.00PM</td></tr>
                                <tr><td>2</td><td>04/07/2020</td><td>Clinical discussion on abdomen - DCLD</td><td>Prof Hariharan, Director MMC</td><td>2.00PM - 04.00PM</td></tr>
                                <tr><td>3</td><td>04/07/2020</td><td>Viral pneumonias with emphasis on COVID 19 pneumonia</td><td>Dr Bharath Kathi, S V Medical College, Thirupathi</td><td>6.00PM - 08.00PM</td></tr>
                                <tr><td>4</td><td>11/07/2020</td><td>Clinical discussion on myelopathies</td><td>Prof Lakshmi Narasimhan, Director of Neurology, MMC</td><td>2.00PM - 04.00PM</td></tr>
                                <tr><td>5</td><td>11/07/2020</td><td>Targetted therapy in Oncology</td><td>Dr Biswajith Dubashi, JIPMER Pondicherry</td><td>6.00PM - 08.00PM</td></tr>
                                <tr><td>6</td><td>18/07/2020</td><td>Clinical discussion on pleural effusion</td><td>Prof M Natarajan, HOD GRH Madurai</td><td>2.00PM - 04.00PM</td></tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>

  );
};

export default GeneralDepartment;